export const DICT = 'Dict'
